export default __webpack_public_path__ + "static/media/uploadtcno.76a2bba8.svg";